import Lottie from "react-lottie-player";
import lottieJson from "../asset/JSON/order-sucess.json";
import { Link, useSearchParams } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderDataThunk } from "../store/stripe";
import { clearCoupon } from "../store/coupons";
import { buyPointsThunk } from "../store/rewards";
import Context from "../Context";

const OrderConfirmed = () => {
  const dispatch = useDispatch();
  const { restaurantId } = useContext(Context);
  const orderFromStore = useSelector((state) => state.orders.order);
  const [searchParams] = useSearchParams();
  const paymentIntentId = searchParams.get("payment_intent");
  const [orderId, setOrderId] = useState(orderFromStore?.order_id || null);
  const [pickupNumber, setPickupNumber] = useState(orderFromStore?.pickup_number || null);
  const [loading, setLoading] = useState(!!paymentIntentId);
  const [error, setError] = useState(false);

  useEffect(() => {
    const clearCartStorage = () => {
      localStorage.removeItem("cart");
      localStorage.removeItem("freeItem");
      localStorage.removeItem("rewardItem");
      localStorage.removeItem(`discountReward-${restaurantId}`);
      dispatch(clearCoupon());
    };

    const awardPointsOnce = async (orderData) => {
      const pointsKey = `pointsAwarded-${restaurantId}`;
      const storedOrderId = localStorage.getItem(pointsKey);
      if (storedOrderId !== orderData?.order_id && orderData?.phone) {
        await dispatch(
          buyPointsThunk(
            orderData?.restaurant_id || restaurantId,
            orderData?.phone || orderData?.phone_number,
            orderData?.name,
            Number(orderData?.subtotal || 0)
          )
        );
        localStorage.setItem(pointsKey, orderData.order_id);
      }
    };

    if (!paymentIntentId) {
      if (orderFromStore?.order_id) {
        setOrderId(orderFromStore.order_id);
        setPickupNumber(orderFromStore.pickup_number || null);
        clearCartStorage();
        awardPointsOnce(orderFromStore);
      }
      setLoading(false);
      return;
    }

    let cancelled = false;
    const fetchOrderId = async () => {
      const fetched = await dispatch(fetchOrderDataThunk(paymentIntentId));
      if (cancelled) return;

      if (fetched?.order_id) {
        setOrderId(fetched.order_id);
        setPickupNumber(fetched.pickup_number || null);
        clearCartStorage();
        await awardPointsOnce(fetched);
        setLoading(false);
      } else {
        setError(true);
        setLoading(false);
      }
    };

    fetchOrderId();
    return () => {
      cancelled = true;
    };
  }, [paymentIntentId, dispatch, orderFromStore, restaurantId]);

  return (
    <>
      <Toaster className="mt-5" position="bottom-right" reverseOrder />
      <div className="page-content bg-white" style={{ marginTop: "100px", minHeight: "70vh" }}>
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              {loading && (
                <>
                  <div className="spinner-border text-danger mb-4" role="status" />
                  <h3 className="fw-bold">Verifying your order...</h3>
                  <p className="text-muted">Please do not close this page.</p>
                </>
              )}

              {!loading && orderId && (
                <>
                  <Lottie loop animationData={lottieJson} play style={{ maxWidth: 220, margin: "0 auto" }} />
                  <h2 className="fw-bold mt-3">Thank you!</h2>
                  <p className="text-muted mb-4">
                    We&apos;ve received your order. You&apos;ll get a text with updates when it&apos;s ready.
                  </p>
                  <div className="bg-light border border-dashed rounded-4 p-4 d-inline-block mb-4">
                    <div className="small text-uppercase text-muted fw-semibold">Order ID</div>
                    <div className="fs-3 fw-bold font-monospace">#{orderId}</div>
                    {pickupNumber && (
                      <>
                        <div className="small text-uppercase text-muted fw-semibold mt-3">Pickup #</div>
                        <div className="fs-2 fw-bold">{pickupNumber}</div>
                      </>
                    )}
                  </div>
                  <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                    <Link
                      to={`/order/${orderId}/${restaurantId}`}
                      className="btn btn-danger rounded-pill px-4 py-2 fw-semibold"
                    >
                      View Order Receipt
                    </Link>
                    <Link to="/order" className="btn btn-outline-dark rounded-pill px-4 py-2 fw-semibold">
                      Order Again
                    </Link>
                  </div>
                </>
              )}

              {!loading && !orderId && (
                <>
                  <h3 className="fw-bold text-danger">Something went wrong</h3>
                  <p className="text-muted">
                    {error
                      ? "We couldn't verify your payment yet. If you were charged, contact the restaurant with your payment confirmation."
                      : "Order not found. Please contact the restaurant."}
                  </p>
                  <Link to="/" className="btn btn-dark rounded-pill px-4 mt-2">
                    Back to Home
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderConfirmed;
